import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { RecentSearches } from '@/app/(main)/_components/search-modal/search-modal.types';
import { SearchType } from '@/types/most-search-type';

export const buildSearchResult = (
  selectedProcedures: SelectedProcedures[],
  isVaccine: boolean,
): RecentSearches | null => {
  if (selectedProcedures.length === 0) {
    return null;
  }

  const searchType = isVaccine ? SearchType.VACCINE : SearchType.LABORATORIAL_EXAM;
  const searchTypeLabelPlural = isVaccine ? 'vacinas' : 'exames';
  const searchTypeLabelSingular = isVaccine ? 'vacina' : 'exame';

  if (selectedProcedures.length === 1) {
    const [procedure] = selectedProcedures;

    return {
      id: procedure.id,
      code: procedure.code,
      displayName: procedure.displayName,
      searchType,
    };
  }

  const procedureNames = selectedProcedures.map((p) => p.displayName);

  let displayName = '';

  if (procedureNames.length === 2) {
    displayName = procedureNames.join(' e ');
  } else {
    displayName = procedureNames.slice(0, 2).join(', ');
  }

  if (procedureNames.length > 2) {
    const remaining = selectedProcedures.length - 2;

    const label
      = remaining === 1
        ? searchTypeLabelSingular
        : searchTypeLabelPlural.toLowerCase();

    displayName += ` e +${remaining} ${label}`;
  }

  return {
    id: selectedProcedures.map((p) => p.id).join(','),
    code: selectedProcedures.map((p) => p.code).join(','),
    displayName,
    searchType,
    examOrVaccineGroup: selectedProcedures.map((procedure) => ({
      id: procedure.id,
      code: procedure.code,
      displayName: procedure.displayName,
      searchType,
    })),
  };
};
